import {
  getImageFileError,
  getValidationErrorForLargeUploads,
  resetFormErrors,
  showFormErrors,
} from "../../../utils/form";
import {apiUrl} from "../../../utils/urlGenerator";
import trans from "../../../utils/trans";
import * as notification from "../../notifications";

const initFormFieldImage = (imageContainer) => {
  if (imageContainer.data('image-initialized')) {
    return;
  }

  imageContainer.data('image-initialized', true);

  $(".image-uploader-control", imageContainer).change(function() {
      handleImageUpload(imageContainer, this.files[0]);
    }
  )

  $('.remove-logo-btn', imageContainer).click(function() {
    const removedUrl = $('.image-src-value', imageContainer).val();

    handleImageRemove(imageContainer);
    $(this).addClass('d-none')

    deleteUnsavedImage(imageContainer, removedUrl);
  })

  initDragAndDrop(imageContainer);
}

/**
 * Dropping a file anywhere on the uploader uploads it, the same way as picking it with
 * the file input does.
 */
const initDragAndDrop = (container) => {
  const dropArea = getCoverDropzone(container).length ? getCoverDropzone(container) : container;

  dropArea.on('dragenter dragover', function(e) {
    e.preventDefault();
    e.stopPropagation();
    dropArea.addClass('is-dragover');
  });

  dropArea.on('dragleave dragend drop', function(e) {
    e.preventDefault();
    e.stopPropagation();
    dropArea.removeClass('is-dragover');
  });

  dropArea.on('drop', function(e) {
    const files = e.originalEvent.dataTransfer && e.originalEvent.dataTransfer.files;

    if (!files || !files.length) {
      return;
    }

    handleImageUpload(container, files[0]);
  });
}

const handleImageUpload = async (container, file) => {
  if (!file) {
    return;
  }

  const imageModule = container.data('image-module');
  const imageId = container.data('image-id');

  const form = container.closest('form');
  const imageValueHiddenInput = $('.image-src-value', container);
  const replacedUrl = imageValueHiddenInput.val();

  const pickedFileError = getPickedFileError(container, file);

  if (pickedFileError) {
    notification.danger(pickedFileError);
    resetFileInput(container);

    return;
  }

  const data = new FormData();
  data.append('file', file);

  setUploadingState(container, true);

  try {
    const response = await axios.post(`${$jBoard.config.main_api_url}/images/${imageModule}`, data, {
      headers: {
        "X-Use-Team-Trans": 'true'
      }
    });

    setImagePreview(container, response.data.url);
    $('.remove-logo-btn', container).removeClass('d-none');

    imageValueHiddenInput.val(response.data.url);

    resetFormErrors(form);

    deleteUnsavedImage(container, replacedUrl);
  } catch (error) {
    const imageFileName = `image_file_${imageId}`;
    const response = error.response
      ? getValidationErrorForLargeUploads(error.response, imageFileName)
      : null;

    /**
     * Anything that is not a validation error (no response at all, a server error) has no
     * message for the field, so the visitor would be left with nothing without this.
     */
    if (!response || !response.data || !response.data.errors) {
      notification.danger(trans('forms.field.image.upload_failed'));
      resetFileInput(container);

      return;
    }

    if (response.data.errors.file) {
      response.data.errors[imageFileName] = response.data.errors.file;
      delete response.data.errors.file;
    }

    showFormErrors(form, response);
    resetFileInput(container);
  } finally {
    setUploadingState(container, false);
  }
};

/**
 * The limits are rendered by the image component from the module the field uploads to,
 * @see \JBoard\FieldManager\FormFieldImageModule::uploadLimits()
 */
const getPickedFileError = (container, file) => {
  const allowedMimeTypes = (container.data('allowed-mime-types') || '').split(',').filter(Boolean);
  const maxFileSizeKb = container.data('max-file-size-kb') || null;

  return getImageFileError(file, {
    allowedMimeTypes,
    maxFileSizeKb,
    invalidTypeMessage: trans('forms.field.image.invalid_type', {
      ALLOWED_TYPES: allowedMimeTypes.map((mimeType) => mimeType.replace('image/', '').toUpperCase()).join(', '),
    }),
    tooLargeMessage: trans('forms.field.image.too_large', {MAX_FILE_SIZE: maxFileSizeKb / 1000}),
  });
}

/**
 * A refused file has to be cleared, otherwise picking the very same file again fires no
 * "change" event and looks like nothing happens.
 */
const resetFileInput = (container) => {
  $('.image-uploader-control', container).val(null);
}

/**
 * Drops an image that was uploaded here but never saved with the form. An image already
 * stored on the employer is kept: the API refuses to delete it, and it is removed by the
 * employer itself once the form is saved without it.
 */
const deleteUnsavedImage = async (container, imageUrl) => {
  const formFieldId = container.data('form-field-id');

  if (!formFieldId || !imageUrl) {
    return;
  }

  try {
    await axios.delete(apiUrl('/temporary_images'), {
      data: {
        url: imageUrl,
        form_field_id: formFieldId,
      },
      headers: {
        'X-CSRF-TOKEN': $("input[name='_token']", container.closest('form')).val() || window.$jBoard.csrf_token,
      },
    });
  } catch (error) {
    /**
     * Nothing to tell the visitor: the image is already gone from the form and is shown
     * nowhere. It only stays on the storage as an upload that was never saved.
     */
  }
};

/**
 * The cover uploader is the preview itself, so replacing its content with a spinner would
 * drop the image. It gets a spinner overlay instead.
 */
const setUploadingState = (container, isUploading) => {
  if (getCoverDropzone(container).length) {
    container.toggleClass('is-uploading', isUploading);
    return;
  }

  $('.btn-logo-upload', container).loading(isUploading);
}

const setImagePreview = (container, url) => {
  const coverPreview = $('.form-field-image-cover-preview', container);

  if (coverPreview.length) {
    coverPreview.attr('src', url).removeClass('d-none');
    getCoverDropzone(container).addClass('has-image');
    return;
  }

  $('.image-placeholder-preview', container).attr('src', url).removeClass('d-none');
  $('.image-placeholder-preview-icon', container).addClass('d-none');
}

const handleImageRemove = (container) => {
  const coverPreview = $('.form-field-image-cover-preview', container);

  if (coverPreview.length) {
    /** removeAttr, not an empty "src": the browser would request the page URL again. */
    coverPreview.removeAttr('src').addClass('d-none');
    getCoverDropzone(container).removeClass('has-image');
  } else {
    const defaultImagePath = container.data('image-default');
    $('.image-placeholder-preview', container).attr('src', defaultImagePath).addClass('d-none');
    $('.image-placeholder-preview-icon', container).removeClass('d-none');
  }

  $('.image-src-value', container).val(null);
  $('.image-uploader-control', container).val(null);
}

const getCoverDropzone = (container) => $('.form-field-image-cover-dropzone', container);

const initFormFieldImages = () => {
  $('.form-field-image-container').each(function () {
    initFormFieldImage($(this));
  });
}

$(initFormFieldImages);
/** Sections re-rendered by the page builder bring their own uploaders, they need binding too. */
document.addEventListener('jb.section.rendered', initFormFieldImages);
